import React, { useState } from "react";
import withMotion from "../../../Utils/withMotion";
import "../Blog.scss";
import ReactPagination from "react-js-pagination";
import { useHistory } from "react-router-dom";

//Shapes
import { TitleBar } from "../../../Shapes/Shapes";

//Panels
import Sidebar from "../Sidebar/Sidebar";

//Data
import { blogs } from "./Blogs";

//Utils
import { mapBlogs } from "./utils";

//SEO
import SEO from "../../../SEO/index";

const Blog = (props) => {
  const { params } = props.match;
  const [current] = useState(parseInt(params.page));
  const currentPage = parseInt(params.page);
  const blogLength = blogs.length;
  const history = useHistory();

  return (
    <>
      <SEO
        title="Blog | Pacific Pavingstone"
        description="Read our blog to gain ideas around paving stone design and installation and stay up-to-date on the latest company and industry news."
        profileURL={`https://www.pacificpavingstone.com/blog/page/${params.page}`}
        type="website"
      />
      <div className="container-fluid page-pagination">
        <div className="row justify-content-center mb-5">
          <div className="col-9 col-sm-6 col-md-4 col-lg-3 text-center">
            <h1 className="text-uppercase text-blue">Blog</h1>
            <TitleBar />
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-9 col-md-9 col-lg-6">
            {mapBlogs(currentPage, blogs)}
          </div>
          <Sidebar />
        </div>
        <div className="row justify-content-center mb-5">
          <ReactPagination
            innerClass="pagination pagination-lg justify-content-center"
            itemClass="page-item"
            linkClass="page-link"
            activePage={currentPage}
            itemsCountPerPage={5}
            totalItemsCount={blogLength}
            pageRangeDisplayed={3}
            onChange={(page) => history.push(`/blog/page/${page}`)}
          />
        </div>
      </div>
    </>
  );
};

export default withMotion(Blog);
